// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 992px) {
  ion-header .toolbar {
    background-color: var(--ion-color-secondary);
  }
}
ion-header .toolbar ion-icon {
  width: 145px;
  height: 50px;
}
ion-header .toolbar .right-block {
  display: flex;
  justify-content: center;
  align-items: center;
}
ion-header .categories-block {
  height: 30px;
  background-color: transparent;
}
ion-header .categories-block .category-list {
  transition: 1s linear;
  opacity: 1;
  display: flex;
  overflow: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
}
@media (min-width: 991px) {
  ion-header .categories-block .category-list > ion-chip {
    overflow: unset;
    display: flex;
  }
}
ion-header .categories-block .category-list::-webkit-scrollbar {
  display: none;
}
ion-header .categories-block .category-list .line-dotted-block:last-child {
  display: none;
}
ion-header .categories-block .category-list .category-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 30px;
  min-width: -moz-fit-content;
  min-width: fit-content;
}
@media (min-width: 991px) {
  ion-header .categories-block .category-list .category-wrapper {
    padding: 12px 16px !important;
  }
}
ion-header .categories-block .category-list .category-wrapper .category-name {
  font-size: 18px;
  color: #fff;
  text-align: center;
  margin: 0px 10px;
  position: relative;
  cursor: pointer;
}
ion-header .categories-block .category-list .category-wrapper .category-name::before {
  content: "";
  position: absolute;
  bottom: -6px;
  height: 3px;
  width: 0%;
  background-color: var(--ion-color-tertiary);
}
ion-header .categories-block .category-list .category-wrapper:first-child {
  margin-left: 12px;
}
ion-header .categories-block .category-list .category-wrapper:last-child {
  margin-right: 12px;
}
ion-header .categories-block .category-list .category-wrapper.selected .category-name::before {
  content: "";
  position: absolute;
  bottom: -6px;
  height: 3px;
  width: 100%;
  background-color: var(--ion-color-tertiary);
  transition: width 0.2s linear;
}
ion-header .categories-block .category-list .category-wrapper ion-chip {
  opacity: 0.4;
  border-radius: 50%;
  padding: 5px;
  background: white;
  transition: color 200ms linear, background 200ms linear;
  text-transform: capitalize;
  flex: 0 0 auto;
  height: 30px;
  width: 60px;
  margin: 0px;
  padding: 0px;
  position: relative;
}
@media (min-width: 991px) {
  ion-header .categories-block .category-list .category-wrapper ion-chip {
    height: 110px;
    width: 110px;
  }
}
ion-header .categories-block .category-list .category-wrapper ion-chip .category-image {
  width: 100%;
}
ion-header .categories-block .category-list .category-wrapper ion-chip .border-dotted {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 58px;
  height: 58px;
}
@media (min-width: 991px) {
  ion-header .categories-block .category-list .category-wrapper ion-chip .border-dotted {
    height: 107px;
    width: 107px;
  }
}

.item-responsive {
  width: 100%;
}
@media (min-width: 991px) {
  .item-responsive {
    width: calc(25% - 10px);
    margin: 0 5px 10px;
  }
}

.articles-wrapper {
  padding: 18px 20px 0;
}
@media (min-width: 991px) {
  .articles-wrapper {
    margin: 0 -5px;
  }
}

ion-searchbar {
  height: 34px;
  padding-inline-end: 12px;
  padding-inline-start: 12px;
  --placeholder-color: var(--ion-color-secondary);
  --placeholder-opacity: 1;
  --color: var(--ion-color-secondary);
  --icon-color: var(--ion-color-secondary);
  --border-radius: 0px;
  border-radius: 10px;
  font-size: 14px;
  font-family: AppFont, sans-serif;
}
@media (min-width: 991px) {
  ion-searchbar {
    width: auto;
  }
}

.main-row {
  height: 100%;
  overflow: hidden;
  padding-top: 25px;
}

.order-col {
  min-width: 380px;
}

.padding-end {
  padding-right: 11px;
}

ion-footer {
  background-color: var(--ion-color-tertiary);
  border-radius: 50px;
  text-transform: uppercase;
  display: flex;
}

.footer-btn {
  width: 100%;
}
@media (min-width: 991px) {
  .footer-btn {
    display: none;
  }
}

.hidden {
  opacity: 0;
  display: none !important;
  transition: 1s linear !important;
}

.chip {
  background: transparent;
  transition: 200ms linear;
  min-width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
}
@media (min-width: 991px) {
  .chip {
    display: none !important;
  }
}
.chip .chip-icon {
  margin: 0;
  height: 16px;
}

.category-info {
  max-height: 60px;
}
@media (min-width: 991px) {
  .category-info {
    max-height: 80px;
  }
  .category-info ion-img {
    height: 80px;
  }
}
.category-info ion-img {
  height: 60px;
  width: 100%;
  object-fit: cover;
}

.background-image {
  width: 100%;
  height: 30px;
  position: absolute;
  left: 0px;
  top: 0px;
  background: url('test.svg') center top/100% no-repeat !important;
  z-index: 99;
}
@media (min-width: 991px) {
  .background-image {
    height: 45px;
    background: url('test_desktop.svg') center top/103% no-repeat !important;
  }
}

ion-content {
  --offset-top: 4px !important;
}
@media (min-width: 991px) {
  ion-content {
    --offset-top: 23px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/mixins.scss","webpack://./src/app/pages/testing/testing.page.scss"],"names":[],"mappings":"AAOE;ECFA;IAEI,4CAAA;EAJJ;AACF;AAKI;EACE,YAAA;EACA,YAAA;AAHN;AAKI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAHN;AAOE;EACE,YAAA;EACA,6BAAA;AALJ;AASI;EACE,qBAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA,EAAA,YAAA;AAPN;ADzBE;ECmCM;IACE,eAAA;IACA,aAAA;EAPR;AACF;AAWM;EACE,aAAA;AATR;AAWM;EACE,aAAA;AATR;AAYM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,2BAAA;EAAA,sBAAA;AAVR;AD5CE;ECiDI;IAOI,6BAAA;EARR;AACF;AASQ;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACF,eAAA;AAPR;AAQU;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,2CAAA;AANZ;AASQ;EACE,iBAAA;AAPV;AAUQ;EACE,kBAAA;AARV;AAWU;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,2CAAA;EACA,6BAAA;AATZ;AAaQ;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,uDAAA;EACA,0BAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAXV;AD9FE;EC6FM;IAcI,aAAA;IACA,YAAA;EATV;AACF;AAUU;EACE,WAAA;AARZ;AAUU;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;AARZ;AD/GE;ECiHQ;IAQI,aAAA;IACA,YAAA;EANZ;AACF;;AAsBA;EACE,WAAA;AAnBF;ADzHE;EC2IF;IAGI,uBAAA;IACA,kBAAA;EAjBF;AACF;;AAoBA;EACE,oBAAA;AAjBF;ADnIE;ECmJF;IAGI,cAAA;EAfF;AACF;;AAkBA;EACE,YAAA;EACA,wBAAA;EACA,0BAAA;EACA,+CAAA;EACA,wBAAA;EACA,mCAAA;EACA,wCAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;AAfF;ADtJE;EC0JF;IAcI,WAAA;EAdF;AACF;;AAiBA;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;AAdF;;AAmBA;EACE,gBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAkBA;EACE,2CAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;AAfF;;AAsBA;EACE,WAAA;AAnBF;ADpLE;ECsMF;IAGI,aAAA;EAjBF;AACF;;AAoBA;EACE,UAAA;EACA,wBAAA;EACA,gCAAA;AAjBF;;AAqBA;EACE,uBAAA;EACA,wBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAlBF;ADzME;ECoNF;IASI,wBAAA;EAhBF;AACF;AAiBE;EACE,SAAA;EACA,YAAA;AAfJ;;AAoBA;EACE,gBAAA;AAjBF;ADtNE;ECsOF;IAGI,gBAAA;EAfF;EAgBE;IACE,YAAA;EAdJ;AACF;AAgBE;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AAdJ;;AAiBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACE,gEAAA;EAKF,WAAA;AAlBF;AD7OE;ECoPF;IAQM,YAAA;IACA,wEAAA;EAXJ;AACF;;AAcA;EACE,4BAAA;AAXF;ADvPE;ECiQF;IAGM,6BAAA;EATJ;AACF","sourcesContent":["@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n","@import \"../../../theme/mixins\";\n\n\nion-header {\n\n  .toolbar {\n    @include mobile {\n      background-color: var(--ion-color-secondary);\n    }\n    ion-icon {\n      width: 145px;\n      height: 50px;\n    }\n    .right-block {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n\n  .categories-block {\n    height: 30px;\n    background-color: transparent;\n\n\n\n    .category-list {\n      transition: 1s linear;\n      opacity: 1;\n      display: flex;\n      overflow: auto;\n      scroll-behavior: smooth;\n      -ms-overflow-style: none;\n      scrollbar-width: none; /* Firefox */\n      @include desktop {\n      \n        > ion-chip {\n          overflow: unset;\n          display: flex;\n          // flex-grow: 1 !important;\n        }\n      }\n    \n      &::-webkit-scrollbar {\n        display: none;\n      }\n      .line-dotted-block:last-child {\n        display: none;\n      }\n\n      .category-wrapper {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        height: 30px;\n        min-width: fit-content;\n        @include desktop {\n          padding: 12px 16px !important;\n        }\n        .category-name {\n          font-size: 18px;\n          color: #fff;\n          text-align: center;\n          margin: 0px 10px;\n          position: relative;\n        cursor: pointer;\n          &::before {\n            content: '';\n            position: absolute;\n            bottom: -6px;\n            height: 3px;\n            width: 0%;\n            background-color: var(--ion-color-tertiary);\n          }\n        }\n        &:first-child {\n          margin-left: 12px;\n        }\n      \n        &:last-child {\n          margin-right: 12px;\n        }\n        &.selected {\n          .category-name::before {\n            content: '';\n            position: absolute;\n            bottom: -6px;\n            height: 3px;\n            width: 100%;\n            background-color: var(--ion-color-tertiary);\n            transition: width 0.2s linear;\n          }\n        }\n      \n        ion-chip {\n          opacity: 0.4;\n          border-radius: 50%;\n          padding: 5px;\n          background: white;\n          transition: color 200ms linear, background 200ms linear;\n          text-transform: capitalize;\n          flex: 0 0 auto;\n          height: 30px;\n          width: 60px;\n          margin: 0px;\n          padding: 0px;\n          position: relative;\n          @include desktop {\n            height: 110px;\n            width: 110px;\n          }\n          .category-image {\n            width: 100%;\n          }\n          .border-dotted {\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%,-50%);\n            width: 58px;\n            height: 58px;\n            @include desktop {\n              height: 107px;\n              width: 107px;\n            }\n          }\n        }\n       \n      }\n    }    \n  }\n}\n\n\n\n\n\n\n\n\n.item-responsive {\n  width: 100%;\n  @include desktop {\n    width: calc(25% - 10px);\n    margin: 0 5px 10px;\n  }\n}\n\n.articles-wrapper {\n  padding: 18px 20px 0;\n  @include desktop {\n    margin: 0 -5px;\n  }\n}\n\nion-searchbar {\n  height: 34px;\n  padding-inline-end: 12px;\n  padding-inline-start: 12px;\n  --placeholder-color: var(--ion-color-secondary);\n  --placeholder-opacity: 1;\n  --color: var(--ion-color-secondary);\n  --icon-color: var(--ion-color-secondary);\n  --border-radius: 0px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-family: AppFont, sans-serif;\n\n  @include desktop {\n    width: auto;\n  }\n}\n\n.main-row {\n  height: 100%;\n  overflow: hidden;\n  padding-top: 25px;\n}\n\n\n\n.order-col {\n  min-width: 380px;\n}\n\n.padding-end{\n  padding-right: 11px;\n}\nion-footer {\n  background-color: var(--ion-color-tertiary);\n  border-radius: 50px;\n  text-transform: uppercase;\n  display: flex;\n\n  \n}\n.search-block {\n \n}\n.footer-btn {\n  width: 100%;\n  @include desktop {\n    display: none;\n  }\n}\n\n.hidden {\n  opacity: 0;\n  display: none !important;\n  transition: 1s linear !important;\n\n}\n\n.chip {\n  background: transparent;\n  transition: 200ms linear;\n  min-width: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 30px;\n  @include desktop {\n    display: none !important;\n  }\n  .chip-icon {\n    margin: 0;\n    height: 16px;\n  }\n}\n\n\n.category-info {\n  max-height: 60px;\n  @include desktop {\n    max-height: 80px;\n    ion-img {\n      height: 80px;\n    }\n  }\n  ion-img {\n    height: 60px;\n    width: 100%;\n    object-fit: cover;\n  }\n}\n.background-image {\n  width: 100%;\n  height: 30px;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n    background: url('../../../assets/tabilo/test.svg') center top/100% no-repeat !important;\n  @include desktop{\n      height: 45px;\n      background: url('../../../assets/tabilo/test_desktop.svg') center top/103% no-repeat !important;\n  }\n  z-index: 99;\n}\nion-content {\n  --offset-top: 4px !important;\n  @include desktop {\n      --offset-top: 23px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
